export const planningMessages = {
  uz: {
    planning: {
      appTitle: 'Ishlab chiqarishni rejalashtirish',
      appDescription: 'Quvvat, smenalar, material mavjudligi, uskuna yuklamasi va ishlab chiqarish jadvali.',
      eyebrow: 'Rejalashtirish',
      nav: {
        schedule: 'Jadval',
        calendar: 'Kalendar',
        capacity: 'Quvvat',
        orders: 'Ishlab chiqarish buyurtmalari',
        materials: 'Materiallar',
        rescheduling: 'Qayta rejalashtirish',
        shifts: 'Smenalarni rejalashtirish',
        batches: 'Partiyalarni rejalashtirish',
        machineLoading: 'Uskuna yuklamasi',
      },
      schedule: {
        title: 'Jadval doskasi',
        description: 'Ishlab chiqarish buyurtmalarini ish markazi, chiqarish holati va material tayyorligi bo‘yicha ko‘ring.',
        openRescheduling: 'Qayta rejalashtirishni ochish',
        plannedOrders: 'Rejalangan buyurtmalar',
        pairsScheduled: 'Rejalangan juftlar',
        released: 'Chiqarilgan',
        blocked: 'Bloklangan',
        capacityWarning: 'Quvvat ogohlantirishi',
        capacityWarningText: '{centers} ushbu davrda mavjud soatlardan oshib ketgan.',
        noOrders: 'Buyurtmalar rejalashtirilmagan.',
        overdue: 'Muddati o‘tgan',
        overdueHint: 'Tugash sanasi o‘tgan, yopilmagan buyurtmalar',
        missingDates: 'Sanasiz buyurtmalar',
        missingDatesHint: 'Boshlanish yoki tugash sanasi yo‘q',
        warnings: 'Reja ogohlantirishlari',
      },
      calendar: {
        title: 'Ishlab chiqarish kalendari',
        description: 'Chiqarilgan va qoralama buyurtmalar bo‘yicha kunlik boshlanish va tugash sanalarini ko‘ring.',
        start: 'Boshlash',
        finish: 'Tugatish',
        noOrders: 'Tanlangan filtrlar bo‘yicha sanalar yo‘q.',
      },
      capacity: {
        title: 'Ish markazi quvvati',
        description: 'Yangi buyurtmalarni chiqarishdan oldin mavjud soatlar va rejalangan yuklamani solishtiring.',
        workCenter: 'Ish markazi',
        machines: 'Uskunalar',
        availableHours: 'Mavjud soatlar',
        plannedHours: 'Rejalangan soatlar',
        load: 'Yuklama',
        department: 'Bo‘lim',
        orders: 'Buyurtmalar',
        plannedQuantity: 'Reja miqdori',
        machineState: 'Uskuna holati',
        hoursGap: 'Soat normativlari yo‘q',
        hoursGapText: 'Backendda ish markazi jadvali va standart soatlar yo‘q, shuning uchun faqat real uskuna holati va reja yuklamasi ko‘rsatiladi.',
        noLoad: 'Faol buyurtmalar bo‘yicha yuklama yo‘q.',
      },
      orders: {
        title: 'Buyurtmalarni chiqarish',
        description: 'Har bir rejalangan buyurtma uchun ustuvorlik, muddat, materiallar va chiqarish tayyorligini tekshiring.',
        order: 'Buyurtma',
        product: 'Mahsulot',
        customer: 'Mijoz',
        quantity: 'Miqdor',
        due: 'Muddat',
        status: 'Holat',
        materials: 'Materiallar',
        priority: '{priority} ustuvorlik',
        readiness: 'Chiqarishga tayyorlik',
        ready: 'Tayyor',
        release: 'Chiqarish',
        cancelOrder: 'Bekor qilish',
        releaseConfirm: '{code} buyurtmasi chiqarilsinmi?',
        releasedMessage: 'Buyurtma chiqarildi.',
        cancelledMessage: 'Buyurtma bekor qilindi.',
        blockerDates: 'Boshlanish va tugash sanalari to‘ldirilmagan',
        blockerQuantity: 'Reja miqdori noldan katta emas',
        blockerStatus: 'Faqat rejalangan buyurtma chiqarilishi mumkin',
        releaseHint: 'Chiqarish bu yerda holatni o‘zgartiradi; material va quvvatni tekshirish alohida sahifalarda.',
        noOrders: 'Tanlangan filtrlar bo‘yicha buyurtma yo‘q.',
      },
      materials: {
        title: 'Material mavjudligi',
        description: 'Rejalangan chiqarishlar uchun talab qilinadigan va mavjud materiallarni solishtiring.',
        shortages: '{count} ta yetishmovchilik',
        shortagesText: 'Bloklangan buyurtmalarni chiqarishdan oldin yetishmovchiliklarni hal qiling.',
        ready: 'Tayyor',
        short: 'Kam',
        required: 'Talab',
        available: 'Mavjud',
        linkedOrders: 'Bog‘langan buyurtmalar',
        material: 'Material',
        ordersChecked: 'Tekshirilgan buyurtmalar: {count}',
        warnings: 'BOM topilmadi: {count}',
        noRequirements: 'Faol buyurtmalar uchun talablar topilmadi.',
        bomMissing: '{product} uchun faol BOM yo‘q.',
        scopeNote: 'Talab BOM materiallari × reja miqdori (+ yo‘qotish) bo‘yicha, mavjudlik esa barcha omborlar qoldig‘i yig‘indisi bo‘yicha hisoblanadi.',
      },
      rescheduling: {
        title: 'Nazoratli qayta rejalashtirish',
        description: 'Yangi jadval versiyasini tasdiqlashdan oldin xavflar va tavsiya etilgan ko‘chirishlarni ko‘ring.',
        createVersion: 'Jadval versiyasini yaratish',
        recommendedActions: 'Tavsiya etilgan amallar',
        moveOrder: '{code} buyurtmasini {center} dan {date} dan keyingi mos oynaga ko‘chiring.',
        reduceLoad: '{center} yuklamasini {hours} soatga kamaytiring yoki qo‘shimcha ish vaqtini qo‘shing.',
        versionNotes: 'Versiya izohlari',
        versionNotesText: 'Keyingi saqlash quvvat va material snapshot bilan V-2026-09-26-02 versiyasini yaratadi.',
        guardrails: 'Chiqarish cheklovlari',
        guardrailsText: 'Bloklangan buyurtmalar va yetishmayotgan materiallar rejalashtirish istisnoni tasdiqlamaguncha yopiq qoladi.',
        currentWindow: 'Joriy oraliq',
        newStart: 'Yangi boshlanish',
        newEnd: 'Yangi tugash',
        save: 'Saqlash',
        saved: '{code} qayta rejalashtirildi.',
        guardrailDates: 'Tugash sanasi boshlanishdan oldin',
        guardrailPast: 'Tugash sanasi o‘tgan',
        guardrailText: 'Backendda jadval versiyalari saqlanmaydi, shuning uchun o‘zgarishlar to‘g‘ridan-to‘g‘ri buyurtmaga yoziladi.',
        blockedStatus: 'Qayta rejalashtirilmaydi',
        blockedText: 'Yopilgan yoki bekor qilingan {count} buyurtma tahrirlanmaydi.',
        noOrders: 'Qayta rejalashtirish uchun faol buyurtma yo‘q.',
        editHint: 'Sanalarni o‘zgartirib saqlang; cheklovlar saqlashdan oldin tekshiriladi.',
      },
      status: {
        draft: 'Qoralama',
        ready: 'Tayyor',
        released: 'Chiqarilgan',
        blocked: 'Bloklangan',
        partial: 'Qisman',
        missing: 'Yetishmaydi',
        low: 'Past',
        normal: 'Oddiy',
        high: 'Yuqori',
      },
      common: {
        refresh: 'Yangilash',
        loading: 'Yuklanmoqda…',
        retry: 'Qayta urinish',
        empty: 'Ma’lumot yo‘q.',
        saving: 'Saqlanmoqda…',
        cancel: 'Bekor qilish',
        optional: 'ixtiyoriy',
        actions: 'Amallar',
        order: 'Buyurtma',
        product: 'Mahsulot',
        department: 'Bo‘lim',
        stage: 'Bosqich',
        lot: 'Partiya',
        machine: 'Uskuna',
        operator: 'Operator',
        type: 'Turi',
        status: 'Holat',
        shift: 'Smena',
        notes: 'Izohlar',
        assignedAt: 'Tayinlangan',
        startDate: 'Boshlanish sanasi',
        planned: 'Rejalangan',
        produced: 'Ishlab chiqarilgan',
        searchPlaceholder: 'Buyurtma, bosqich, uskuna yoki operator bo‘yicha qidirish…',
        selectOrder: 'Buyurtmani tanlang',
        selectStage: 'Bosqichni tanlang',
        selectMachine: 'Uskunani tanlang',
        noLot: 'Partiya yo‘q',
        endDate: 'Tugash sanasi',
        rows: '{count} qator',
        showing: '{from}–{to} / {total} ko‘rsatilmoqda',
        allStatuses: 'Barcha holatlar',
        apply: 'Qo‘llash',
        page: '{page} / {total} sahifa',
        previous: 'Oldingi',
        next: 'Keyingi',
      },
      shift: {
        day: 'Kunduzgi smena',
        night: 'Tungi smena',
      },
      machineStatus: {
        running: 'Ishlamoqda',
        idle: 'Bo‘sh',
        down: 'To‘xtagan',
        setup: 'Sozlanmoqda',
      },
      orderStatus: {
        planned: 'Rejalangan',
        in_progress: 'Jarayonda',
        completed: 'Tugallangan',
        cancelled: 'Bekor qilingan',
      },
      lotStatus: {
        active: 'Faol',
        completed: 'Tugallangan',
        cancelled: 'Bekor qilingan',
      },
      shifts: {
        eyebrow: 'Smenalarni rejalashtirish',
        title: 'Smena qamrovi',
        description: 'Bitta smena uchun chiqarilgan buyurtmalarning qamrovi real uskuna va operator tayinlovlari asosida.',
        machinesAssigned: 'Tayinlangan uskunalar',
        running: 'Ishlamoqda',
        operatorsAssigned: 'Tayinlangan operatorlar',
        activeAssignments: '{count} faol tayinlov',
        ordersWithoutMachine: 'Uskunasiz buyurtmalar',
        releasedOrders: 'Chiqarilgan buyurtmalar',
        machineIssues: 'Mavjud bo‘lmagan uskunalar',
        machineIssuesHint: 'To‘xtagan, sozlanayotgan yoki ochiq nuqsoni bor',
        ordersWithoutAssignment: 'Bu smenada tayinlovsiz chiqarilgan buyurtmalar',
        coverage: 'Bosqichlar qamrovi',
        machines: 'Uskunalar',
        operators: 'Operatorlar',
        noMachine: 'Uskuna yo‘q',
        noCoverage: 'Bu smenada hali tayinlovlar yo‘q.',
        activeAssignmentList: 'Faol tayinlovlar',
        noAssignments: 'Faol tayinlovlar yo‘q.',
        resource: 'Resurs',
        release: 'Bo‘shatish',
        releaseConfirm: 'Tayinlov tugatilib, resurs bo‘shatilsinmi?',
        releaseHint: 'Quyidagi ro‘yxatdan bo‘shating',
        released: 'Tayinlov bo‘shatildi.',
        gapHint: 'Smena jadvali va shtat normativlari backendda modellashtirilmagan; qamrov joriy tayinlovlar bo‘yicha ko‘rsatiladi.',
      },
      machineLoading: {
        eyebrow: 'Uskuna yuklamasi',
        title: 'Uskuna yuklamasi',
        description: 'Qaysi uskuna qaysi buyurtma, bosqich va partiyani bajaradi hamda uskuna holati bilan mosligi.',
        allStatuses: 'Barcha holatlar',
        newBooking: 'Uskunani band qilish',
        ofTotal: '{total} uskunadan',
        booked: '{count} band qilingan',
        unavailable: 'Mavjud emas',
        mismatches: 'Bandlik mos emas',
        mismatchHint: 'Uskuna band qilinganidan boshqa buyurtmani bajar moqda',
        attention: 'E’tibor talab qiladi',
        mismatchText: 'Band qilingan: {booking}, uskuna ko‘rsatmoqda: {running}.',
        unbookedText: '{order} bajarilmoqda, bu smenada band qilinmagan.',
        machines: 'Uskunalar',
        currentOrder: 'Ko‘rsatayotgan buyurtma',
        bookedOrder: 'Band qilingan buyurtma',
        progress: 'Ishlab chiqarilgan / reja',
        fault: 'Ochiq nuqson',
        book: 'Band qilish',
        release: 'Bo‘shatish',
        releaseConfirm: '{machine} joriy bandlikdan bo‘shatilsinmi?',
        released: 'Uskuna bo‘shatildi.',
        invalidMachine: 'Uskunani tanlang.',
        invalidOrder: 'Buyurtmani tanlang.',
        invalidStage: 'Bosqichni tanlang.',
      },
      batches: {
        eyebrow: 'Partiyalarni rejalashtirish',
        title: 'Partiyalarni rejalashtirish',
        description: 'Chiqarilgan buyurtmani partiyalarga bo‘ling va allaqachon bo‘lingan qismini kuzatib boring.',
        allStatuses: 'Barcha holatlar',
        noOrder: 'Partiyalarni rejalashtirish uchun buyurtmani tanlang.',
        batched: 'Partiyalarga bo‘lingan',
        lots: '{count} partiya',
        openQuantity: 'Ochiq miqdor',
        openHint: 'Hali partiyalarga bo‘linmagan reja miqdori',
        activeLots: 'Faol partiyalar',
        newBatch: 'Yangi partiya',
        quantity: 'Partiya miqdori',
        createBatch: 'Partiya yaratish',
        policyHint: 'Backendda standart partiya hajmi yo‘q, shuning uchun taklif ochiq miqdor bo‘yicha beriladi.',
        lotList: 'Partiyalar',
        noLots: 'Bu buyurtma uchun hali partiya yaratilmagan.',
        initial: 'Boshlang‘ich',
        current: 'Joriy',
        created: 'Yaratilgan',
        batchCreated: 'Partiya yaratildi.',
        invalidOrder: 'Buyurtmani tanlang.',
        invalidStage: 'Bosqichni tanlang.',
        invalidQuantity: 'Partiya miqdori noldan katta bo‘lishi kerak.',
      },
    },
  },
  ru: {
    planning: {
      appTitle: 'Планирование производства',
      appDescription: 'Мощности, смены, наличие материалов, загрузка оборудования и производственный график.',
      eyebrow: 'Планирование',
      nav: {
        schedule: 'График',
        calendar: 'Календарь',
        capacity: 'Мощности',
        orders: 'Производственные заказы',
        materials: 'Материалы',
        rescheduling: 'Перепланирование',
        shifts: 'Планирование смен',
        batches: 'Планирование партий',
        machineLoading: 'Загрузка оборудования',
      },
      schedule: {
        title: 'Доска графика',
        description: 'Просматривайте заказы по рабочему центру, статусу выпуска и готовности материалов.',
        openRescheduling: 'Открыть перепланирование',
        plannedOrders: 'Плановые заказы',
        pairsScheduled: 'Пар запланировано',
        released: 'Выпущено',
        blocked: 'Заблокировано',
        capacityWarning: 'Предупреждение по мощности',
        capacityWarningText: '{centers} превышает доступные часы в этом периоде.',
        noOrders: 'Заказы не запланированы.',
        overdue: 'Просрочено',
        overdueHint: 'Незакрытые заказы с прошедшей датой окончания',
        missingDates: 'Заказы без дат',
        missingDatesHint: 'Нет даты старта или окончания',
        warnings: 'Предупреждения графика',
      },
      calendar: {
        title: 'Производственный календарь',
        description: 'Ежедневные старты и завершения по выпущенным и черновым заказам.',
        start: 'Старт',
        finish: 'Финиш',
        noOrders: 'По выбранным фильтрам дат нет.',
      },
      capacity: {
        title: 'Мощность рабочих центров',
        description: 'Сравните доступные часы с текущей загрузкой перед выпуском новых заказов.',
        workCenter: 'Рабочий центр',
        machines: 'Оборудование',
        availableHours: 'Доступные часы',
        plannedHours: 'Плановые часы',
        load: 'Загрузка',
        department: 'Подразделение',
        orders: 'Заказы',
        plannedQuantity: 'Плановое количество',
        machineState: 'Состояние оборудования',
        hoursGap: 'Нормы часов отсутствуют',
        hoursGapText: 'В бэкенде нет календаря рабочих центров и стандартных часов, поэтому показаны только фактическое состояние оборудования и плановая загрузка.',
        noLoad: 'Нет загрузки по активным заказам.',
      },
      orders: {
        title: 'Выпуск заказов',
        description: 'Проверьте приоритет, срок, материалы и готовность к выпуску каждого заказа.',
        order: 'Заказ',
        product: 'Продукт',
        customer: 'Клиент',
        quantity: 'Количество',
        due: 'Срок',
        status: 'Статус',
        materials: 'Материалы',
        priority: 'Приоритет: {priority}',
        readiness: 'Готовность к выпуску',
        ready: 'Готов',
        release: 'Выпустить',
        cancelOrder: 'Отменить',
        releaseConfirm: 'Выпустить заказ {code}?',
        releasedMessage: 'Заказ выпущен.',
        cancelledMessage: 'Заказ отменён.',
        blockerDates: 'Не заполнены даты старта и окончания',
        blockerQuantity: 'Плановое количество не больше нуля',
        blockerStatus: 'Выпустить можно только запланированный заказ',
        releaseHint: 'Выпуск здесь меняет статус; проверка материалов и мощностей — на других страницах.',
        noOrders: 'По выбранным фильтрам заказов нет.',
      },
      materials: {
        title: 'Наличие материалов',
        description: 'Сравните потребность и наличие материалов для плановых выпусков.',
        shortages: 'Дефицитов: {count}',
        shortagesText: 'Устраните дефициты перед выпуском заблокированных заказов.',
        ready: 'Готово',
        short: 'Дефицит',
        required: 'Требуется',
        available: 'Доступно',
        linkedOrders: 'Связанные заказы',
        material: 'Материал',
        ordersChecked: 'Проверено заказов: {count}',
        warnings: 'BOM не найден: {count}',
        noRequirements: 'Для активных заказов потребности не найдены.',
        bomMissing: 'Нет активного BOM для {product}.',
        scopeNote: 'Потребность рассчитана как материалы BOM × плановое количество (+потери), наличие — как сумма остатков по всем складам.',
      },
      rescheduling: {
        title: 'Контролируемое перепланирование',
        description: 'Проверьте риски и рекомендуемые переносы перед сохранением новой версии графика.',
        createVersion: 'Создать версию графика',
        recommendedActions: 'Рекомендуемые действия',
        moveOrder: 'Перенести {code} из {center} в ближайшее подходящее окно после {date}.',
        reduceLoad: 'Снизить загрузку {center} на {hours} ч или добавить сверхурочные.',
        versionNotes: 'Заметки версии',
        versionNotesText: 'Следующее сохранение создаст V-2026-09-26-02 со снимком мощностей и материалов.',
        guardrails: 'Ограничения выпуска',
        guardrailsText: 'Заблокированные заказы и отсутствующие материалы остаются закрытыми до подтверждения исключения.',
        currentWindow: 'Текущее окно',
        newStart: 'Новый старт',
        newEnd: 'Новое окончание',
        save: 'Сохранить',
        saved: '{code} перепланирован.',
        guardrailDates: 'Окончание раньше старта',
        guardrailPast: 'Дата окончания в прошлом',
        guardrailText: 'Версии графика в бэкенде не хранятся, поэтому изменения записываются напрямую в заказ.',
        blockedStatus: 'Не перепланируется',
        blockedText: '{count} завершённых или отменённых заказов не редактируются.',
        noOrders: 'Нет активных заказов для перепланирования.',
        editHint: 'Измените даты и сохраните; ограничения проверяются до записи.',
      },
      status: {
        draft: 'Черновик',
        ready: 'Готово',
        released: 'Выпущено',
        blocked: 'Заблокировано',
        partial: 'Частично',
        missing: 'Нет',
        low: 'Низкий',
        normal: 'Обычный',
        high: 'Высокий',
      },
      common: {
        refresh: 'Обновить',
        loading: 'Загрузка…',
        retry: 'Повторить',
        empty: 'Нет данных.',
        saving: 'Сохранение…',
        cancel: 'Отмена',
        optional: 'необязательно',
        actions: 'Действия',
        order: 'Заказ',
        product: 'Продукт',
        department: 'Подразделение',
        stage: 'Этап',
        lot: 'Партия',
        machine: 'Оборудование',
        operator: 'Оператор',
        type: 'Тип',
        status: 'Статус',
        shift: 'Смена',
        notes: 'Заметки',
        assignedAt: 'Назначено',
        startDate: 'Дата старта',
        planned: 'План',
        produced: 'Изготовлено',
        searchPlaceholder: 'Поиск по заказу, этапу, оборудованию или оператору…',
        selectOrder: 'Выберите заказ',
        selectStage: 'Выберите этап',
        selectMachine: 'Выберите оборудование',
        noLot: 'Без партии',
        endDate: 'Дата окончания',
        rows: 'Строк: {count}',
        showing: 'Показано {from}–{to} из {total}',
        allStatuses: 'Все статусы',
        apply: 'Применить',
        page: 'Стр. {page} из {total}',
        previous: 'Назад',
        next: 'Вперёд',
      },
      shift: {
        day: 'Дневная смена',
        night: 'Ночная смена',
      },
      machineStatus: {
        running: 'Работает',
        idle: 'Простой',
        down: 'Остановлено',
        setup: 'Наладка',
      },
      orderStatus: {
        planned: 'Запланирован',
        in_progress: 'В работе',
        completed: 'Завершён',
        cancelled: 'Отменён',
      },
      lotStatus: {
        active: 'Активная',
        completed: 'Завершена',
        cancelled: 'Отменена',
      },
      shifts: {
        eyebrow: 'Планирование смен',
        title: 'Покрытие смены',
        description: 'Покрытие выпущенных заказов для одной смены по фактическим назначениям оборудования и операторов.',
        machinesAssigned: 'Назначено оборудования',
        running: 'Работает',
        operatorsAssigned: 'Назначено операторов',
        activeAssignments: 'Активных назначений: {count}',
        ordersWithoutMachine: 'Заказы без оборудования',
        releasedOrders: 'Выпущенные заказы',
        machineIssues: 'Недоступное оборудование',
        machineIssuesHint: 'Остановлено, в наладке или с открытой неисправностью',
        ordersWithoutAssignment: 'Выпущенные заказы без назначений в этой смене',
        coverage: 'Покрытие этапов',
        machines: 'Оборудование',
        operators: 'Операторы',
        noMachine: 'Нет оборудования',
        noCoverage: 'В этой смене пока нет назначений.',
        activeAssignmentList: 'Активные назначения',
        noAssignments: 'Активных назначений нет.',
        resource: 'Ресурс',
        release: 'Освободить',
        releaseConfirm: 'Завершить назначение и освободить ресурс?',
        releaseHint: 'Освободите из списка ниже',
        released: 'Назначение освобождено.',
        gapHint: 'График смен и штатные нормативы в бэкенде не смоделированы; покрытие показано по текущим назначениям.',
      },
      machineLoading: {
        eyebrow: 'Загрузка оборудования',
        title: 'Загрузка оборудования',
        description: 'Какое оборудование выполняет какой заказ, этап и партию и совпадает ли это с его состоянием.',
        allStatuses: 'Все статусы',
        newBooking: 'Забронировать оборудование',
        ofTotal: 'из {total} единиц',
        booked: 'забронировано: {count}',
        unavailable: 'Недоступно',
        mismatches: 'Несовпадения брони',
        mismatchHint: 'Оборудование выполняет не тот заказ, что забронирован',
        attention: 'Требует внимания',
        mismatchText: 'Забронировано: {booking}, оборудование сообщает: {running}.',
        unbookedText: 'Выполняется {order} без брони на эту смену.',
        machines: 'Оборудование',
        currentOrder: 'Текущий заказ',
        bookedOrder: 'Забронированный заказ',
        progress: 'Изготовлено / план',
        fault: 'Открытая неисправность',
        book: 'Забронировать',
        release: 'Освободить',
        releaseConfirm: 'Освободить {machine} от текущей брони?',
        released: 'Оборудование освобождено.',
        invalidMachine: 'Выберите оборудование.',
        invalidOrder: 'Выберите заказ.',
        invalidStage: 'Выберите этап.',
      },
      batches: {
        eyebrow: 'Планирование партий',
        title: 'Планирование партий',
        description: 'Разделите выпущенный заказ на партии и отслеживайте, что уже разбито на партии.',
        allStatuses: 'Все статусы',
        noOrder: 'Выберите заказ, чтобы спланировать партии.',
        batched: 'В партиях',
        lots: 'Партий: {count}',
        openQuantity: 'Открытое количество',
        openHint: 'Плановое количество, ещё не разбитое на партии',
        activeLots: 'Активные партии',
        newBatch: 'Новая партия',
        quantity: 'Количество в партии',
        createBatch: 'Создать партию',
        policyHint: 'В бэкенде нет стандартного размера партии, поэтому предлагается открытое количество.',
        lotList: 'Партии',
        noLots: 'Для этого заказа партии ещё не созданы.',
        initial: 'Начальное',
        current: 'Текущее',
        created: 'Создана',
        batchCreated: 'Партия создана.',
        invalidOrder: 'Выберите заказ.',
        invalidStage: 'Выберите этап.',
        invalidQuantity: 'Количество в партии должно быть больше нуля.',
      },
    },
  },
  en: {
    planning: {
      appTitle: 'Production Planning',
      appDescription: 'Capacity, shifts, material availability, machine loading, and production scheduling.',
      eyebrow: 'Planning',
      nav: {
        schedule: 'Schedule',
        calendar: 'Calendar',
        capacity: 'Capacity',
        orders: 'Production orders',
        materials: 'Materials',
        rescheduling: 'Rescheduling',
        shifts: 'Shift planning',
        batches: 'Batch planning',
        machineLoading: 'Machine loading',
      },
      schedule: {
        title: 'Schedule board',
        description: 'Review planned production orders by work center, release status, and material readiness.',
        openRescheduling: 'Open rescheduling',
        plannedOrders: 'Planned orders',
        pairsScheduled: 'Pairs scheduled',
        released: 'Released',
        blocked: 'Blocked',
        capacityWarning: 'Capacity warning',
        capacityWarningText: '{centers} exceeds available hours this period.',
        noOrders: 'No orders planned.',
        overdue: 'Overdue',
        overdueHint: 'Unclosed orders with a past end date',
        missingDates: 'Orders without dates',
        missingDatesHint: 'Missing start or end date',
        warnings: 'Schedule warnings',
      },
      calendar: {
        title: 'Production calendar',
        description: 'See daily starts and due dates across released and draft production orders.',
        start: 'Start',
        finish: 'Finish',
        noOrders: 'No dates for the selected filters.',
      },
      capacity: {
        title: 'Work-center capacity',
        description: 'Compare available hours against current planned load before releasing additional orders.',
        workCenter: 'Work center',
        machines: 'Machines',
        availableHours: 'Available hours',
        plannedHours: 'Planned hours',
        load: 'Load',
        department: 'Department',
        orders: 'Orders',
        plannedQuantity: 'Planned quantity',
        machineState: 'Machine state',
        hoursGap: 'No standard hours',
        hoursGapText: 'The backend has no work-center calendar or standard hours, so only real machine state and planned load are shown.',
        noLoad: 'No load from active orders.',
      },
      orders: {
        title: 'Production-order release',
        description: 'Check priority, due date, materials, and release readiness for each planned order.',
        order: 'Order',
        product: 'Product',
        customer: 'Customer',
        quantity: 'Quantity',
        due: 'Due',
        status: 'Status',
        materials: 'Materials',
        priority: '{priority} priority',
        readiness: 'Release readiness',
        ready: 'Ready',
        release: 'Release',
        cancelOrder: 'Cancel',
        releaseConfirm: 'Release order {code}?',
        releasedMessage: 'Order released.',
        cancelledMessage: 'Order cancelled.',
        blockerDates: 'Start and end date are not set',
        blockerQuantity: 'Planned quantity is not above zero',
        blockerStatus: 'Only a planned order can be released',
        releaseHint: 'Release changes the status here; material and capacity checks live on their own pages.',
        noOrders: 'No orders for the selected filters.',
      },
      materials: {
        title: 'Material availability',
        description: 'Compare required and available materials for planned releases.',
        shortages: '{count} shortages',
        shortagesText: 'Resolve shortages before releasing blocked production orders.',
        ready: 'Ready',
        short: 'Short',
        required: 'Required',
        available: 'Available',
        linkedOrders: 'Linked orders',
        material: 'Material',
        ordersChecked: 'Orders checked: {count}',
        warnings: 'Missing BOM: {count}',
        noRequirements: 'No requirements found for active orders.',
        bomMissing: 'No active BOM for {product}.',
        scopeNote: 'Requirement is BOM material × planned quantity (+loss) and availability is the stock sum across warehouses.',
      },
      rescheduling: {
        title: 'Controlled rescheduling',
        description: 'Review schedule risks and suggested moves before committing a new schedule version.',
        createVersion: 'Create schedule version',
        recommendedActions: 'Recommended actions',
        moveOrder: 'Move {code} from {center} to the next feasible slot after {date}.',
        reduceLoad: 'Reduce {center} load by {hours} hours or add overtime.',
        versionNotes: 'Version notes',
        versionNotesText: 'Next save will create version V-2026-09-26-02 with a capacity and material snapshot.',
        guardrails: 'Release guardrails',
        guardrailsText: 'Blocked orders and missing materials stay locked until planning confirms an exception.',
        currentWindow: 'Current window',
        newStart: 'New start',
        newEnd: 'New end',
        save: 'Save',
        saved: '{code} rescheduled.',
        guardrailDates: 'End date is before the start date',
        guardrailPast: 'End date is in the past',
        guardrailText: 'Schedule versions are not stored by the backend, so changes are written straight to the order.',
        blockedStatus: 'Not reschedulable',
        blockedText: '{count} completed or cancelled orders are not editable.',
        noOrders: 'No active orders to reschedule.',
        editHint: 'Change the dates and save; the guardrails are checked before the write.',
      },
      status: {
        draft: 'Draft',
        ready: 'Ready',
        released: 'Released',
        blocked: 'Blocked',
        partial: 'Partial',
        missing: 'Missing',
        low: 'Low',
        normal: 'Normal',
        high: 'High',
      },
      common: {
        refresh: 'Refresh',
        loading: 'Loading…',
        retry: 'Retry',
        empty: 'Nothing to show.',
        saving: 'Saving…',
        cancel: 'Cancel',
        optional: 'optional',
        actions: 'Actions',
        order: 'Order',
        product: 'Product',
        department: 'Department',
        stage: 'Stage',
        lot: 'Batch',
        machine: 'Machine',
        operator: 'Operator',
        type: 'Type',
        status: 'Status',
        shift: 'Shift',
        notes: 'Notes',
        assignedAt: 'Assigned',
        startDate: 'Start date',
        planned: 'Planned',
        produced: 'Produced',
        searchPlaceholder: 'Search by order, stage, machine or operator…',
        selectOrder: 'Select order',
        selectStage: 'Select stage',
        selectMachine: 'Select machine',
        noLot: 'No batch',
        endDate: 'End date',
        rows: '{count} rows',
        showing: 'Showing {from}–{to} of {total}',
        allStatuses: 'All statuses',
        apply: 'Apply',
        page: 'Page {page} of {total}',
        previous: 'Previous',
        next: 'Next',
      },
      shift: {
        day: 'Day shift',
        night: 'Night shift',
      },
      machineStatus: {
        running: 'Running',
        idle: 'Idle',
        down: 'Down',
        setup: 'Setup',
      },
      orderStatus: {
        planned: 'Planned',
        in_progress: 'In progress',
        completed: 'Completed',
        cancelled: 'Cancelled',
      },
      lotStatus: {
        active: 'Active',
        completed: 'Completed',
        cancelled: 'Cancelled',
      },
      shifts: {
        eyebrow: 'Shift planning',
        title: 'Shift coverage',
        description: 'Coverage of released orders for one shift, derived from real machine and operator assignments.',
        machinesAssigned: 'Machines assigned',
        running: 'Running',
        operatorsAssigned: 'Operators assigned',
        activeAssignments: '{count} active assignments',
        ordersWithoutMachine: 'Orders without machine',
        releasedOrders: 'Released orders',
        machineIssues: 'Machines unavailable',
        machineIssuesHint: 'Down or in setup, or with an open fault',
        ordersWithoutAssignment: 'Released orders with no assignment in this shift',
        coverage: 'Stage coverage',
        machines: 'Machines',
        operators: 'Operators',
        noMachine: 'No machine',
        noCoverage: 'No assignments in this shift yet.',
        activeAssignmentList: 'Active assignments',
        noAssignments: 'No active assignments.',
        resource: 'Resource',
        release: 'Release',
        releaseConfirm: 'End this assignment and free the resource?',
        releaseHint: 'Release from the list below',
        released: 'Assignment released.',
        gapHint: 'Shift rosters and staffing standards are not modelled in the backend; coverage is shown against current assignments.',
      },
      machineLoading: {
        eyebrow: 'Machine loading',
        title: 'Machine loading',
        description: 'Which machine carries which order, stage and batch, and whether the machine agrees with its booking.',
        allStatuses: 'All statuses',
        newBooking: 'Book machine',
        ofTotal: 'of {total} machines',
        booked: '{count} booked',
        unavailable: 'Unavailable',
        mismatches: 'Booking mismatches',
        mismatchHint: 'Machine running a different order than booked',
        attention: 'Needs attention',
        mismatchText: 'Booked {booking}, machine reports {running}.',
        unbookedText: 'Running {order} without a booking for this shift.',
        machines: 'Machines',
        currentOrder: 'Reports order',
        bookedOrder: 'Booked order',
        progress: 'Produced / planned',
        fault: 'Open fault',
        book: 'Book',
        release: 'Release',
        releaseConfirm: 'Release {machine} from its current booking?',
        released: 'Machine released.',
        invalidMachine: 'Select a machine.',
        invalidOrder: 'Select an order.',
        invalidStage: 'Select a stage.',
      },
      batches: {
        eyebrow: 'Batch planning',
        title: 'Batch planning',
        description: 'Split a released order into batches (lots) and track what is already batched.',
        allStatuses: 'All statuses',
        noOrder: 'Select an order to plan its batches.',
        batched: 'Batched',
        lots: '{count} batches',
        openQuantity: 'Open quantity',
        openHint: 'Planned quantity not yet batched',
        activeLots: 'Active batches',
        newBatch: 'New batch',
        quantity: 'Batch quantity',
        createBatch: 'Create batch',
        policyHint: 'The backend has no standard batch size, so the suggested quantity is the open quantity.',
        lotList: 'Batches',
        noLots: 'No batches created for this order yet.',
        initial: 'Initial',
        current: 'Current',
        created: 'Created',
        batchCreated: 'Batch created.',
        invalidOrder: 'Select an order.',
        invalidStage: 'Select a stage.',
        invalidQuantity: 'Batch quantity must be greater than zero.',
      },
    },
  },
}
